import { render, staticRenderFns } from "./CoreSelectionDrawer.vue?vue&type=template&id=6ac9c8d4&"
import script from "./CoreSelectionDrawer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CoreSelectionDrawer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ac9c8d4')) {
      api.createRecord('6ac9c8d4', component.options)
    } else {
      api.reload('6ac9c8d4', component.options)
    }
    module.hot.accept("./CoreSelectionDrawer.vue?vue&type=template&id=6ac9c8d4&", function () {
      api.rerender('6ac9c8d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue"
export default component.exports